import type { UserData } from '@cosuno/analytics-frontend';

import { COMPANY_TYPE, type CurrentUserQuery, SALESFORCE_PACKAGE_TYPE } from '#@/__gql__/graphql';

type CurrentUser_me = CurrentUserQuery['me'];

const getPlanFromUser = (user: CurrentUser_me) => {
  if (user.company.type === COMPANY_TYPE.agent) {
    return user.company.config.premiumEnabled ? 'Premium' : 'No pricing package';
  }

  const { packageType } = user.company;

  if (packageType) {
    return {
      [SALESFORCE_PACKAGE_TYPE.bronze]: 'Bronze',
      [SALESFORCE_PACKAGE_TYPE.silver]: 'Silver',
      [SALESFORCE_PACKAGE_TYPE.gold]: 'Gold',
      [SALESFORCE_PACKAGE_TYPE.enterprise]: 'Enterprise',
      [SALESFORCE_PACKAGE_TYPE.noPricingPackage]: 'Licence-based',
      [SALESFORCE_PACKAGE_TYPE.freeTrial]: 'Free Trial',
    }[packageType];
  }

  return 'No associated plan';
};

export const getUserName = ({
  firstName,
  lastName,
}: {
  firstName: string | null;
  lastName: string | null;
}): string => [firstName, lastName].filter(Boolean).join(' ');

export const mapUserToUserData = (user: CurrentUser_me): UserData => {
  const { firstName, lastName, language, email, company, type } = user;

  return {
    commonData: {
      id: user.id,
      fullName: getUserName(user),
      firstName,
      lastName,
      email,
      company: {
        id: company.id,
        name: company.name,
        type: company.type,
        plan: getPlanFromUser(user),
        tags: company.tags,
        flags: company.permanentFeatureFlags,
      },
      type,
      language,
    },
    intercomData: {
      intercomHash: user.intercomHash,
      jobTitle: user.jobTitle,
    },
    mixpanelData: {
      lastActivityAt: user.lastActivityAt,
    },
  };
};
